import { GradientColor } from '@/color/classes/GradientColor';
import { SolidColor } from '@/color/classes/SolidColor';
import { Filter } from '@/elements/medias/filter/classes/Filter';
import { GradientOverlay, SolidOverlay } from '@/elements/medias/filter/classes/Overlay';

export class FilterPresetEmpty extends Filter {
	constructor() {
		super();
		this.name = 'empty';
	}
}

export class FilterPresetGrayscale extends Filter {
	constructor() {
		super({
			grayscale: 100,
		});

		this.name = 'Grayscale';
	}
}

export class FilterPreset1977 extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(243, 106, 188, 0.3),
			blendMode: 'screen',
		});

		super({
			brightness: 110,
			contrast: 110,
			saturate: 130,
			overlay,
		});

		this.name = '1977';
	}
}

export class FilterEarlyBird extends Filter {
	constructor() {
		const color = new GradientColor('radial', 0, [
			{ r: 208, g: 186, b: 142, a: 1, offset: 20 },
			{ r: 29, g: 2, b: 16, a: 1, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'overlay',
		});

		super({
			brightness: 90,
			contrast: 100,
			saturate: 100,
			sepia: 20,
			overlay,
		});

		this.name = 'Early Bird';
	}
}

export class FilterAden extends Filter {
	constructor() {
		const color = new GradientColor('linear', 0, [
			{ r: 66, g: 10, b: 14, a: 1, offset: 1 },
			{ r: 66, g: 10, b: 14, a: 0, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'darken',
		});

		super({
			brightness: 90,
			contrast: 120,
			saturate: 85,
			hueRotate: 20,
			overlay,
		});

		this.name = 'Aden';
	}
}

export class FilterAmaro extends Filter {
	constructor() {
		super({
			brightness: 90,
			contrast: 110,
			saturate: 150,
			hueRotate: -10,
		});

		this.name = 'Amaro';
	}
}

export class FilterBrannan extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(161, 44, 199, 0.31),
			blendMode: 'lighten',
		});

		super({
			brightness: 140,
			contrast: 100,
			saturate: 100,
			sepia: 50,
			overlay,
		});

		this.name = 'Brannan';
	}
}

export class FilterBrooklyn extends Filter {
	constructor() {
		const color = new GradientColor('radial', 0, [
			{ r: 168, g: 223, b: 193, a: 1, offset: 1 },
			{ r: 183, g: 196, b: 200, a: 1, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'overlay',
		});

		super({
			brightness: 90,
			contrast: 110,
			saturate: 100,
			overlay,
		});

		this.name = 'Brooklyn';
	}
}

export class FilterClarendon extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(127, 187, 227, 0.2),
			blendMode: 'overlay',
		});

		super({
			brightness: 120,
			contrast: 100,
			saturate: 125,
			overlay,
		});

		this.name = 'Clarendon';
	}
}

export class FilterGingham extends Filter {
	constructor() {
		const color = new GradientColor('linear', 0, [
			{ r: 66, g: 10, b: 14, a: 1, offset: 1 },
			{ r: 0, g: 0, b: 0, a: 0, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'darken',
		});

		super({
			brightness: 100,
			contrast: 105,
			saturate: 100,
			hueRotate: 350,
			overlay,
		});

		this.name = 'Gingham';
	}
}

export class FilterHudson extends Filter {
	constructor() {
		const color = new GradientColor('radial', 0, [
			{ r: 255, g: 177, b: 166, a: 1, offset: 50 },
			{ r: 52, g: 33, b: 52, a: 1, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'multiply',
			opacity: 50,
		});

		super({
			brightness: 90,
			contrast: 120,
			saturate: 110,
			overlay,
		});

		this.name = 'Hudson';
	}
}

export class FilterInkwell extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(0, 0, 0, 0),
			blendMode: 'normal',
		});

		super({
			brightness: 110,
			contrast: 110,
			saturate: 100,
			sepia: 30,
			grayscale: 100,
			overlay,
		});

		this.name = 'Inkwell';
	}
}

export class FilterLofi extends Filter {
	constructor() {
		const color = new GradientColor('radial', 0, [
			{ r: 0, g: 0, b: 0, a: 0, offset: 70 },
			{ r: 34, g: 34, b: 34, a: 1, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'multiply',
		});

		super({
			brightness: 150,
			contrast: 100,
			saturate: 110,
			overlay,
		});

		this.name = 'Lofi';
	}
}

export class FilterMaven extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(3, 230, 26, 0.2),
			blendMode: 'hue',
		});

		super({
			brightness: 95,
			contrast: 95,
			saturate: 150,
			sepia: 25,
			overlay,
		});

		this.name = 'Maven';
	}
}

export class FilterPerpetua extends Filter {
	constructor() {
		const color = new GradientColor('linear', 270, [
			{ r: 0, g: 91, b: 154, a: 1, offset: 1 },
			{ r: 61, g: 193, b: 230, a: 0, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'soft-light',
			opacity: 50,
		});

		super({
			brightness: 100,
			contrast: 100,
			saturate: 100,
			overlay,
		});

		this.name = 'Perpetua';
	}
}

export class FilterReyes extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(173, 205, 239, 1),
			blendMode: 'soft-light',
			opacity: 50,
		});

		super({
			brightness: 85,
			contrast: 110,
			saturate: 75,
			sepia: 22,
			overlay,
		});

		this.name = 'Reyes';
	}
}

export class FilterStinson extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(240, 149, 128, 0.2),
			blendMode: 'soft-light',
		});

		super({
			brightness: 75,
			contrast: 115,
			saturate: 85,
			overlay,
		});

		this.name = 'Stinson';
	}
}

export class FilterToaster extends Filter {
	constructor() {
		const color = new GradientColor('radial', 0, [
			{ r: 15, g: 78, b: 128, a: 1, offset: 1 },
			{ r: 59, g: 0, b: 59, a: 1, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'screen',
			opacity: 50,
		});

		super({
			brightness: 150,
			contrast: 90,
			saturate: 100,
			overlay,
		});

		this.name = 'Toaster';
	}
}

export class FilterWalden extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(204, 68, 0, 1),
			blendMode: 'screen',
			opacity: 30,
		});

		super({
			brightness: 100,
			contrast: 110,
			saturate: 160,
			sepia: 30,
			hueRotate: 350,
			overlay,
		});

		this.name = 'Walden';
	}
}

export class FilterValencia extends Filter {
	constructor() {
		const overlay = new SolidOverlay({
			color: new SolidColor(58, 3, 57, 1),
			blendMode: 'exclusion',
			opacity: 50,
		});

		super({
			brightness: 108,
			contrast: 108,
			saturate: 100,
			sepia: 8,
			overlay,
		});

		this.name = 'Valencia';
	}
}

export class FilterXpro2 extends Filter {
	constructor() {
		const color = new GradientColor('radial', 0, [
			{ r: 244, g: 231, b: 230, a: 1, offset: 40 },
			{ r: 43, g: 42, b: 161, a: 1, offset: 100 },
		]);
		const overlay = new GradientOverlay({
			color,
			blendMode: 'color-burn',
			opacity: 50,
		});

		super({
			brightness: 100,
			contrast: 100,
			saturate: 100,
			sepia: 30,
			overlay,
		});

		this.name = 'Xpro2';
	}
}

export const presetTypes = (): Filter[] => [
	new FilterPresetGrayscale(),
	new FilterPreset1977(),
	new FilterEarlyBird(),
	new FilterAden(),
	new FilterAmaro(),
	new FilterBrannan(),
	new FilterBrooklyn(),
	new FilterClarendon(),
	new FilterGingham(),
	new FilterHudson(),
	new FilterInkwell(),
	new FilterLofi(),
	new FilterMaven(),
	new FilterPerpetua(),
	new FilterReyes(),
	new FilterStinson(),
	new FilterToaster(),
	new FilterWalden(),
	new FilterValencia(),
	new FilterXpro2(),
];
